export const MONTHS_FR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

export function formatDateFrench(dateString: string): string {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return `${date.getDate()} ${MONTHS_FR[date.getMonth()]} ${date.getFullYear()}`;
}

export function calculatePercentage(part: number, total: number, digits = 0): number {
    if (total === 0) return 0;
    return ((part / total) * 100).toFixed(digits) as unknown as number;
}

export function formatAmount(amount: number, round?: boolean) {
    const intFormat = new Intl.NumberFormat('fr-FR');
    if (round === true) { amount = Math.ceil(amount); }
    return intFormat.format(amount);
}

export function formatDate(dateString: string, format = 'DD/MM/YYYY HH:mm') {
    const date = new Date(dateString);

    const map = {
        DD: String(date.getDate()).padStart(2, '0'),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        YYYY: date.getFullYear(),
        HH: String(date.getHours()).padStart(2, '0'),
        mm: String(date.getMinutes()).padStart(2, '0'),
        ss: String(date.getSeconds()).padStart(2, '0'),
    };

    let formatted = format;
    for (const [key, value] of Object.entries(map)) {
        formatted = formatted.replace(key, value as any);
    }

    return formatted;
}

export function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export const INTEGER_FORMAT_CONFIG = {
    masked: false,
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: ',',
    precision: 0,
    disableNegative: true,
    disabled: false,
    min: null,
    max: null,
    allowBlank: false,
    minimumNumberOfCharacters: 0,
    shouldRound: true,
    focusOnRight: false,
};

export const AMOUNT_FORMAT_CONFIG = {
    masked: false,
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: ',',
    precision: 2,
    disableNegative: false,
    disabled: false,
    min: null,
    max: null,
    allowBlank: false,
    minimumNumberOfCharacters: 0,
    shouldRound: true,
    focusOnRight: false,
};

export const PERCENTAGE_FORMAT_CONFIG = {
    masked: false,
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: ',',
    precision: 0,
    disableNegative: true,
    disabled: false,
    min: 0,
    max: 100,
    allowBlank: false,
    minimumNumberOfCharacters: 1,
    shouldRound: true,
    focusOnRight: false,
};

export enum MARKET_COMMANDE_MOTIF_REJET {
    // AUTRES
    OTHER = 'OTHER',

    // CLIENT
    CLIENT_REQUEST = 'CLIENT_REQUEST',
    INVALID_CUSTOMER_INFO = 'INVALID_CUSTOMER_INFO',
    CUSTOMER_BLACKLISTED = 'CUSTOMER_BLACKLISTED',

    // PAIEMENT
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PAYMENT_TIMEOUT = 'PAYMENT_TIMEOUT',
    PAYMENT_REFUSED = 'PAYMENT_REFUSED',
    FRAUD_SUSPECTED = 'FRAUD_SUSPECTED',

    // STOCK / PRODUIT
    OUT_OF_STOCK = 'OUT_OF_STOCK',
    PRODUCT_UNAVAILABLE = 'PRODUCT_UNAVAILABLE',
    PRICE_ERROR = 'PRICE_ERROR',
    INVALID_PRODUCT = 'INVALID_PRODUCT',

    // LOGISTIQUE
    DELIVERY_ZONE_UNAVAILABLE = 'DELIVERY_ZONE_UNAVAILABLE',
    DELIVERY_DELAY_TOO_LONG = 'DELIVERY_DELAY_TOO_LONG',
    INVALID_ADDRESS = 'INVALID_ADDRESS',
    CARRIER_UNAVAILABLE = 'CARRIER_UNAVAILABLE',

    // SÉCURITÉ
    DUPLICATE_ORDER = 'DUPLICATE_ORDER',
    SUSPICIOUS_ACTIVITY = 'SUSPICIOUS_ACTIVITY',
}

export const MARKET_COMMANDE_MOTIF_REJET_OPTIONS_GROUPED: any[] = [
    {
        category: 'CLIENT',
        reasons: [
        {
            code: MARKET_COMMANDE_MOTIF_REJET.CLIENT_REQUEST,
            label: 'Annulation à la demande du client',
            category: 'CLIENT',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.CUSTOMER_BLACKLISTED,
            label: 'Client blacklisté',
            category: 'CLIENT',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.INVALID_CUSTOMER_INFO,
            label: 'Informations client invalides',
            category: 'CLIENT',
        },
        ],
    },
    {
        category: 'PAYMENT',
        reasons: [
        {
            code: MARKET_COMMANDE_MOTIF_REJET.PAYMENT_FAILED,
            label: 'Échec du paiement',
            category: 'PAYMENT',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.PAYMENT_REFUSED,
            label: 'Paiement refusé',
            category: 'PAYMENT',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.PAYMENT_TIMEOUT,
            label: 'Temps de paiement expiré',
            category: 'PAYMENT',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.FRAUD_SUSPECTED,
            label: 'Suspicion de fraude',
            category: 'PAYMENT',
        },
        ],
    },
    {
        category: 'STOCK',
        reasons: [
        {
            code: MARKET_COMMANDE_MOTIF_REJET.OUT_OF_STOCK,
            label: 'Rupture de stock',
            category: 'STOCK',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.PRODUCT_UNAVAILABLE,
            label: 'Produit indisponible',
            category: 'STOCK',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.PRICE_ERROR,
            label: 'Erreur de prix',
            category: 'STOCK',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.INVALID_PRODUCT,
            label: 'Produit invalide',
            category: 'STOCK',
        },
        ],
    },
    {
        category: 'LOGISTIC',
        reasons: [
        {
            code: MARKET_COMMANDE_MOTIF_REJET.INVALID_ADDRESS,
            label: 'Adresse de livraison invalide',
            category: 'LOGISTIC',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.DELIVERY_DELAY_TOO_LONG,
            label: 'Délai de livraison trop long',
            category: 'LOGISTIC',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.CARRIER_UNAVAILABLE,
            label: 'Transporteur indisponible',
            category: 'LOGISTIC',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.DELIVERY_ZONE_UNAVAILABLE,
            label: 'Zone de livraison non couverte',
            category: 'LOGISTIC',
        },
        ],
    },
    {
        category: 'SECURITY',
        reasons: [
        {
            code: MARKET_COMMANDE_MOTIF_REJET.DUPLICATE_ORDER,
            label: 'Commande en doublon',
            category: 'SECURITY',
        },
        {
            code: MARKET_COMMANDE_MOTIF_REJET.SUSPICIOUS_ACTIVITY,
            label: 'Activité suspecte détectée',
            category: 'SECURITY',
        },
        ]
    },
    {
        category: 'OTHER',
        reasons: [
        {
            code: MARKET_COMMANDE_MOTIF_REJET.OTHER,
            label: 'Autre (préciser dans les commentaires)',
            category: 'OTHER',
        },
        ],
    },
];